import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';

export default function LinkList({ blok }) {
  if (!blok.links) {
    return null;
  }

  return (
    <div
      {...storyblokEditable(blok)}
      className="pt-20 lg:pt-36 max-w-fit mx-auto px-4 lg:px-16 "
    >
      {blok.links.map((link, index) => {
        const modifiedUrl = link.link.cached_url.replace(/\/([^/]+)$/, '/#$1');
        return (
          <a
            href={`${modifiedUrl.startsWith('/') ? '' : '/'}${modifiedUrl}`}
            key={`link-${index}`}
            className="inline-block px-4 py-2 font-bold"
          >
            {link.LinkText}
          </a>
        );
      })}
    </div>
  );
}
